import { useState, useRef } from "react";
import SelectModal from "./SelectModal";
import classes from "../../styles/Modal.module.css";
import Commander from "../../commander";
import { useAppDispatch, useAppSelector, useTranslation } from "../../hooks";
import { delayedCloseModal } from "../../store/slices/modals";
import { setAutoplay } from "../../store/slices/autoplay";
import { RootState } from "../../store";
import ModalButton from "../buttons/ModalButton";
import { formatCurrency } from "../../utils";
import { AutoplayLimit } from "../../commander/Types";
// import Switch from "../Switch";

const AutoplaySelect: React.FC<{ shown: boolean }> = (props) => {
  const { autoplay } = useAppSelector((state: RootState) => state);
  const currency = useAppSelector((state) => state.details.currency);
  const stake = useAppSelector((state) => state.selectors.stake);
  const [value, setValue] = useState(0);
  const dispatch = useAppDispatch();
  const selectRef = useRef(null);
  const [bonusLimit] = useState(autoplay.limit.bonus.active);
  const onButtonClick = () => {
    const delay = 200 / 2;
    const limitValue = parseFloat((selectRef.current as any).value) || 0;

    dispatch(delayedCloseModal("autoplay", delay));

    if (value <= 0) return;

    const limit = {
      loss: {
        active: limitValue > 0,
        value: limitValue,
      },
      bonus: { active: bonusLimit },
    };

    Commander.startAutoplay(value, limit as AutoplayLimit);
    Commander.startSpin(delay + 200);
  };

  return (
    <SelectModal
      {...props}
      className="select-autoplay"
      data={autoplay}
      cols={2}
      flow="row"
      soundEffect="button-click"
      onClose={() => {
        dispatch(setAutoplay({ value: 0 }));
        setValue(0);
      }}
      onShowStart={setValue.bind(null, 0)}
      onSelect={(value) => {
        if (value === autoplay.value) return;
        dispatch(setAutoplay({ value, active: false }));
        setValue(value);
      }}
    >
      <div className={classes.controls}>
        <div className={classes.limits}>
          <hr />
          <div className={classes["loss-limit-label"]}>
            {useTranslation("losslimit")}
          </div>
          <select
            ref={selectRef}
            defaultValue=""
            className={classes["loss-limit"]}
          >
            <option value="0">----------</option>
            {autoplay.limit.loss.values.map((v, i) => (
              <option key={i} value={v * stake.value}>
                {formatCurrency(v * stake.value, currency)}
              </option>
            ))}
          </select>
          <hr />
        </div>
        <div className={classes["content-button"]}>
          <ModalButton
            disabled={value === 0}
            fill={true}
            type="accent"
            minHeight="2.8em"
            onClick={onButtonClick}
          >
            {useTranslation("ok")}
          </ModalButton>
        </div>
      </div>
    </SelectModal>
  );
};

export default AutoplaySelect;
